<p-toast></p-toast>
<div class="grid">
  <div class="col-12">
    <div class="card dashboardTable">
      <p-toolbar styleClass="mb-4" reflow="true">
        <ng-template pTemplate="left">
          <button pButton pRipple label="{{'ADD_ON_FARM_MI'| translate}}" icon="pi pi-plus" class="p-button-success mr-2"
            (click)="openNew()"></button>
        </ng-template>
        <ng-template pTemplate="right">
          <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
            class="p-button-help"></button>
          <p-menu #menu [popup]="true" [model]="items"></p-menu>
        </ng-template>

      </p-toolbar>

      <p-table #dt [value]="lstOnFarmMiModel" [rows]="10" [paginator]="true"
        [globalFilterFields]="['Land_ID','Year_subsidy','Water_Quality','Bal_Area','Dept_Subsidy']"
        [(selection)]="selectedOnFarmMi" [rowHover]="true" dataKey="id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}" [showCurrentPageReport]="true"
        responsiveLayout="scroll" [loading]="loading">

        <ng-template pTemplate="caption">
          <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 class="m-0">{{'MANAGE_FARM_MI'| translate}}</h5>
            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <i class="pi pi-search"></i>
              <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                placeholder="{{'SEARCH'| translate}}" />
            </span>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="Land_ID">{{'LAND_DETAILS'| translate}}
              <p-columnFilter type="text" field="Land_ID" display="menu"></p-columnFilter>
              <p-sortIcon field="Land_ID"></p-sortIcon>
            </th>
            <th pSortableColumn="Year_subsidy">{{'YEAR_SUBSIDY'| translate}}
              <p-columnFilter type="text" field="Year_subsidy" display="menu"></p-columnFilter>
              <p-sortIcon field="Year_subsidy"></p-sortIcon>
            </th>
            <!-- <th pSortableColumn="Water_Quality">Water Quailty
              <p-columnFilter type="text" field="Water_Quality" display="menu"></p-columnFilter>
              <p-sortIcon field="Water_Quality"></p-sortIcon>
            </th> -->
            <th pSortableColumn="Bal_Area">{{'BALANCE_AREA'| translate}}
              <p-columnFilter type="text" field="Bal_Area" display="menu"></p-columnFilter>
              <p-sortIcon field="Bal_Area"></p-sortIcon>
            </th>
            <th pSortableColumn="Dept_Subsidy">{{'DEPARTMENT'| translate}}
              <p-columnFilter type="text" field="Dept_Subsidy" display="menu"></p-columnFilter>
              <p-sortIcon field="Dept_Subsidy">
              </p-sortIcon>
            </th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
          <tr>
            <td>{{product.landDetailsToDisplay}}</td>
            <td>{{product.Year_subsidy}}</td>
            <!-- <td>{{product.Water_Quality}}</td> -->
            <td>{{product.Bal_Area}}</td>
            <td>{{product.Dept_Subsidy}}</td>
            <td>
              <div *ngIf="product.IsEdit == 0">
                <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                  (click)="editProduct(product)"></button>
                <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"
                  (click)="deleteProduct(product)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between">
            {{'IN_TOTAL_THERE_ARE'| translate}} {{lstOnFarmMiModel ? lstOnFarmMiModel.length : 0 }} {{'LAND_DETAILS_ADDED'| translate}}.
          </div>
        </ng-template>
      </p-table>
    </div>
    <p-dialog [(visible)]="productDialog" [style]="{ width: '60%', height: '80%' }" header="Existing On Farm MI" [modal]="true"
      reflow="true" class="p-fluid">
      <ng-template pTemplate="content">
        <form [formGroup]="onFarmMIForm">
          <div class="grid p-fluid mt-2">
            <div class="field col-12 md:col-6">
              <label htmlFor="state">{{'IS_SUBSIDY_AVAILED'| translate}}?</label>
              <div class="formgroup-inline">
                <div class="field">
                  <div class="field-radiobutton mb-0">
                    <p-radioButton [value]="1" formControlName="isSubsidyAvailabe" [(ngModel)]="isSubsidyAvailabe"
                      id="IsSubsidyAvailabeYes"></p-radioButton>
                    <label for="IsSubsidyAvailabeYes">{{'YES'| translate}}</label>
                  </div>
                </div>
                <div class="field">
                  <div class="field-radiobutton mb-0">
                    <p-radioButton [value]="0" formControlName="isSubsidyAvailabe" [(ngModel)]="isSubsidyAvailabe"
                      id="IsSubsidyAvailabeNo">
                    </p-radioButton>
                    <label for="IsSubsidyAvailabeNo">{{'NO'| translate}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid p-fluid mt-3">
            <div class="field col-12 md:col-6">
              <label htmlFor="address">{{'LAND'| translate}}</label>

              <p-autoComplete formControlName="landDetails" [(ngModel)]="selectedLandDetail"
                [suggestions]="filteredLandDetails" (completeMethod)="filterLandDetails($event)" (onSelect)="changeLD()"
                field="description" value="LandID" id="dd" [dropdown]="true"
                [ngClass]="{ 'g-invalid ng-dirty': submitted && f.landDetails.errors }">
              </p-autoComplete>

              <div *ngIf="submitted && f.landDetails.errors" class="invalid-feedback">
                <div *ngIf="f.landDetails.errors.required">{{'LAND_DETAILS_IS_REQUIRED'| translate}}</div>
              </div>
            </div>
            <div class="field col-12 md:col-6">
              <label htmlFor="address">{{'COMPONENT'| translate}}</label>

              <p-autoComplete [(ngModel)]="selectedcompMaster" formControlName="componentMaster"
                placeholder="{{'COMPONENT_MASTER_SEARCH'| translate}}" id="Program_Id" [dropdown]="true" [multiple]="false"
                [suggestions]="filteredComponentMaster" (completeMethod)="filterComponentMaster($event)"
                field="Program_Name" [ngClass]="{ 'g-invalid ng-dirty': submitted && f.componentMaster.errors }">
              </p-autoComplete>
              <div *ngIf="submitted && f.componentMaster.errors" class="invalid-feedback">
                <div *ngIf="f.componentMaster.errors.required">{{'COMPONENT_MASTER_IS_REQUIRED'| translate}}</div>
              </div>
            </div>
          </div>

          <div class="grid p-fluid mt-3" *ngIf="isSubsidyAvailabe == 1">
            <div class="field col-12 md:col-6">
              <label htmlFor="departmentSubsidy">{{'DEPARTMENT'| translate}}</label>
              <p-dropdown [options]="departmentList" formControlName="departmentSubsidy" optionValue="name" optionLabel="name" placeholder="SELECT_A_DEPARTMENT">
              </p-dropdown>

              <!-- <input pInputText id="departmentSubsidy" class="form-control" type="text"
                formControlName="departmentSubsidy" autofocus="" tabindex="1"
                [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.departmentSubsidy.errors }" /> -->
              <div *ngIf="submitted && f.departmentSubsidy.errors" class="invalid-feedback">
                <div *ngIf="f.departmentSubsidy.errors.required">{{'DEPARTMANT_IS_REQUIRED'| translate}}</div>
              </div>
            </div>
            <div class="field col-12 md:col-6">
              <label htmlFor="yearSubsudy">{{'YEAR'| translate}}</label>
              <p-dropdown [options]="yearArray" formControlName="yearSubsudy" optionValue="name" optionLabel="name" placeholder="SELECT_A_YEAR">
              </p-dropdown>
              <!-- <input pInputText id="yearSubsudy" class="form-control" type="number"  (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)"
                autofocus="" tabindex="1" [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.yearSubsudy.errors }" /> -->
                <div *ngIf="submitted && f.yearSubsudy.errors" class="invalid-feedback">
                  <div *ngIf="f.yearSubsudy.errors.required">{{'YEAR_IS_REQUIRED'| translate}}</div>
                </div>
              <div *ngIf="submitted && f.yearSubsudy.errors" class="invalid-feedback">
                <div *ngIf="f.yearSubsudy.errors.required">{{'YEAR_IS_REQUIRED'| translate}}</div>
              </div>
            </div>
          </div>
          <div class="grid p-fluid mt-3" *ngIf="isSubsidyAvailabe == 0">
            <div class="field col-12 md:col-6" *ngIf="showSubsidyArea">
              <label htmlFor="subsidyArea">{{'SUBSIDY_AREA'| translate}}</label>
              <input readonly pInputText id="subsidyArea" class="form-control" type="text" formControlName="subsidyArea"
                autofocus="" tabindex="1" [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.subsidyArea.errors }"
                (change)="subsidyAreachange($event)" />
              <div *ngIf="submitted && f.subsidyArea.errors" class="invalid-feedback">
                <div *ngIf="f.subsidyArea.errors.required">{{'TOTAL_AREA_IS_REQUIRED'| translate}}</div>
              </div>
            </div>
            <!-- <div class="field col-12 md:col-6">
              <label htmlFor="balanceArea">{{'BALANCE_AREA'| translate}}</label>
              <p-inputNumber [useGrouping]="false" inputId="balanceArea" class="form-control"
                formControlName="balanceArea" autofocus="" tabindex="1"
                [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.balanceArea.errors }"></p-inputNumber>
              <div *ngIf="submitted && f.balanceArea.errors" class="invalid-feedback">
                <div *ngIf="f.balanceArea.errors.required">{{'BALANCE_AREA_IS_REQUIRED'| translate}}</div>
              </div>
            </div> -->
          </div>
        </form>
      </ng-template>

      <ng-template pTemplate="footer">
        <button pButton pRipple label="{{'CANCEL'| translate}}" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
        <button pButton pRipple label="{{'SAVE'| translate}}" icon="pi pi-check" class="p-button-text" (click)="onSubmit()"></button>
      </ng-template>
    </p-dialog>

    <p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>
  </div>
</div>
